import { render, staticRenderFns } from "./cardVirtualAssistantEdit.vue?vue&type=template&id=19086ad0"
import script from "./cardVirtualAssistantEdit.vue?vue&type=script&lang=js"
export * from "./cardVirtualAssistantEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports